// Popular mail domains typed wrongly -> the right one. Mirrors the server's list
// (backend/internal/service/email_check.go): the server refuses these, the form warns earlier.
const TYPO_DOMAINS = {
  'gmail.con': 'gmail.com', 'gmail.cm': 'gmail.com', 'gmail.co': 'gmail.com', 'gmail.om': 'gmail.com',
  'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gamil.com': 'gmail.com', 'gmali.com': 'gmail.com',
  'gmail.ru': 'gmail.com', 'gnail.com': 'gmail.com', 'gmaill.com': 'gmail.com', 'gmil.com': 'gmail.com',
  'mail.ry': 'mail.ru', 'mail.ri': 'mail.ru', 'mail.rux': 'mail.ru', 'mial.ru': 'mail.ru', 'mai.ru': 'mail.ru',
  'maill.ru': 'mail.ru', 'mail.tu': 'mail.ru', 'mail.ur': 'mail.ru', 'mail.r': 'mail.ru', 'mail.com.ru': 'mail.ru',
  'yandex.ry': 'yandex.ru', 'yandex.ri': 'yandex.ru', 'yandex.tu': 'yandex.ru', 'yandex.ur': 'yandex.ru',
  'yandx.ru': 'yandex.ru', 'yadex.ru': 'yandex.ru', 'yande.ru': 'yandex.ru', 'yanex.ru': 'yandex.ru',
  'yndex.ru': 'yandex.ru', 'ya.ry': 'ya.ru', 'ya.ri': 'ya.ru', 'yandex.con': 'yandex.com', 'yandex.ruu': 'yandex.ru',
  'outlok.com': 'outlook.com', 'outllook.com': 'outlook.com', 'outlook.con': 'outlook.com',
  'hotmial.com': 'hotmail.com', 'hotmai.com': 'hotmail.com', 'hotmail.con': 'hotmail.com',
  'yaho.com': 'yahoo.com', 'yahho.com': 'yahoo.com', 'yahoo.con': 'yahoo.com', 'yahooo.com': 'yahoo.com',
  'icloud.con': 'icloud.com', 'iclod.com': 'icloud.com', 'icloud.co': 'icloud.com',
  'bk.ry': 'bk.ru', 'inbox.ry': 'inbox.ru', 'list.ry': 'list.ru', 'rambler.ry': 'rambler.ru',
  'mail.ruu': 'mail.ru', 'gmail.comm': 'gmail.com', 'gmail.coom': 'gmail.com',
};

// Big free mail services outside Russia: our letters do not reach them, so the confirmation code
// would never arrive. Mirrors the server's list (foreignDomains in email_check.go).
const FOREIGN_DOMAINS = new Set([
  'gmail.com', 'googlemail.com', 'outlook.com', 'hotmail.com', 'live.com', 'msn.com', 'passport.com',
  'ymail.com', 'rocketmail.com', 'icloud.com', 'me.com', 'mac.com', 'aol.com', 'aim.com',
  'proton.me', 'protonmail.com', 'protonmail.ch', 'pm.me', 'tutanota.com', 'tuta.io', 'tutamail.com',
  'zoho.com', 'zohomail.com', 'fastmail.com', 'fastmail.fm', 'mail.com', 'email.com', 'web.de', 't-online.de',
  'orange.fr', 'libero.it', 'mailfence.com', 'hushmail.com', 'inbox.com', 'att.net', 'comcast.net',
  'verizon.net', 'sbcglobal.net', 'bellsouth.net', 'cox.net', 'qq.com', '163.com', '126.com', 'naver.com',
]);
const FOREIGN_PREFIXES = ['yahoo.', 'hotmail.', 'gmx.', 'outlook.'];

const domainOf = (email) => {
  const value = String(email || '').trim().toLowerCase();
  const at = value.lastIndexOf('@');
  return at < 1 ? '' : value.slice(at + 1);
};

// isForeignEmail: the address is on a foreign free mail service (or is a typo of one).
export function isForeignEmail(email) {
  const domain = domainOf(email);
  if (!domain) return false;
  if (FOREIGN_DOMAINS.has(domain) || FOREIGN_PREFIXES.some((p) => domain.startsWith(p))) return true;
  const right = TYPO_DOMAINS[domain];
  return Boolean(right && (FOREIGN_DOMAINS.has(right) || FOREIGN_PREFIXES.some((p) => right.startsWith(p))));
}

// suggestEmail returns the address the person probably meant, or '' when nothing looks wrong.
export function suggestEmail(email) {
  if (isForeignEmail(email)) return ''; // not a typo to fix: the service itself is not accepted
  const value = String(email || '').trim().toLowerCase();
  const at = value.lastIndexOf('@');
  if (at < 1) return '';
  const right = TYPO_DOMAINS[value.slice(at + 1)];
  return right ? `${value.slice(0, at + 1)}${right}` : '';
}
